import React, { useState } from 'react';
import styled from 'styled-components';
import {
  IconButton,
  Option,
  Options,
  Popover,
} from '@alefeducation/ui-elements-library-core';
import { EllipsisV } from '@alefeducation/ui-elements-library-icons';
import { MenuOptionFunctionType } from './OrganisationsRows';
import { Organisation } from '../../apollo/queries';
import {
  ACTIVATE_ORGANISATION,
  DEACTIVATE_ORGANISATION,
  EDIT_ORGANISATION,
  VIEW_ORGANISATION,
} from '../../utils/constants';

interface ActionMenuProps {
  isActive?: boolean;
  organisation: Organisation;
  onEditClick: MenuOptionFunctionType;
  onStatusClick: MenuOptionFunctionType;
  isViewOnlyRole: boolean;
}

enum EOptions {
  EDIT_ORG = 'EDIT_ORG',
  STATUS = 'STATUS',
}

const StyledActionMenu = styled.div`
  text-align: left;
`;

const ActionMenu = ({
  onEditClick,
  onStatusClick,
  isActive,
  isViewOnlyRole,
  organisation,
}: ActionMenuProps) => {
  const [buttonRef, setButtonRef] = useState<any>(undefined);
  const [isOpen, togglePopover] = useState<boolean>(false);

  const statusOption = isActive
    ? DEACTIVATE_ORGANISATION
    : ACTIVATE_ORGANISATION;

  const onSelect = (l: string, v?: string, e?: any) => {
    e?.stopPropagation();

    switch (v) {
      case EOptions.EDIT_ORG:
        onEditClick(organisation);
        break;
      case EOptions.STATUS:
        onStatusClick(organisation);
        break;
      default:
        break;
    }
  };

  const renderViewOptions = () => {
    return (
      <Options onSelect={onSelect}>
        <Option value={EOptions.EDIT_ORG}>{VIEW_ORGANISATION}</Option>
        <></>
      </Options>
    );
  };

  const renderEditOptions = () => {
    return (
      <Options onSelect={onSelect}>
        <Option value={EOptions.EDIT_ORG}>{EDIT_ORGANISATION}</Option>
        <Option value={EOptions.STATUS}>{statusOption}</Option>
      </Options>
    );
  };

  return (
    <StyledActionMenu>
      <div
        data-testid="icon-action-menu-container"
        ref={setButtonRef}
        onClick={(e: React.MouseEvent<HTMLDivElement>) => {
          e.stopPropagation();
          togglePopover(!isOpen);
        }}
      >
        <IconButton
          data-testid="icon-action-menu"
          tooltipTestId={organisation.uuid}
          tooltipContent="Actions"
          onClick={() => {}}
        >
          <EllipsisV />
        </IconButton>
      </div>
      {buttonRef && (
        <Popover
          anchorRef={buttonRef!}
          setIsOpen={togglePopover}
          isOpen={isOpen}
        >
          {isViewOnlyRole ? renderViewOptions() : renderEditOptions()}
        </Popover>
      )}
    </StyledActionMenu>
  );
};

export default ActionMenu;
